import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';

export default function DisclaimerText({ message, title }: { message: ReactNode; title?: string }) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-slate-50/70 px-5 py-4 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-indigo-100 p-1.5">
          <InformationCircleIcon className="h-4 w-4 text-indigo-600" />
        </div>
        <div>
          {title && (
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-indigo-700">
              {title}
            </p>
          )}
          <div className="mt-2 space-y-2 text-xs text-slate-600">{message}</div>
        </div>
      </div>
    </section>
  );
}
